<template>
  <div
    @contextmenu.prevent="onContextMenu"
  >
    <div
      :id="id"
      ref="contextElement"
      class="overflow-hidden"
    >
      <slot />
    </div>
    <Teleport to="body">
      <div
        ref="menu"
        class="absolute bg-white shadow-md border flex-col text-sm p-2 overflow-hidden rounded-md z-[35]"
        :style="{ display, ...floatingStyles }"
      >
        <template
          v-for="item in menuItems"
          :key="item.text"
        >
          <slot
            v-if="!item.hidden"
            v-bind="{ item }"
            name="menu-item"
          >
            <button
              :id="item?.id"
              class="grow cursor-pointer hover:bg-gray-100 p-2 inline-flex items-center gap-2"
              :disabled="item.disabled"
              v-bind="item.attrs"
              @click="item.action"
            >
              <AppIcon
                v-if="item.icon"
                :icon="item.icon"
              />
              <span>
                {{ item.text }}
              </span>
            </button>
          </slot>
        </template>
      </div>
    </Teleport>
  </div>
</template>

<script setup lang="ts">
import { shift, flip, offset, autoUpdate, useFloating } from "@floating-ui/vue";

const props = defineProps<{
	menuItems: {
		id?: string;
		text: string;
		icon?: string;
		disabled?: boolean;
		hidden?: boolean;
		attrs?: Record<string, any>;
		action: () => Promise<void> | void;
	}[];
}>();

const id = Math.random().toString(36);
const { menuItems } = toRefs(props);
const contextElement = ref();
const menu = ref();
const trigger = ref(null);
const { floatingStyles } = useFloating(trigger, menu, {
	placement: "bottom-start",
	middleware: [flip(), shift(), offset(4)],
	whileElementsMounted: autoUpdate,
});

let itsMe = false;
const menuOpen = ref(false);
const display = ref("none");
function onContextMenu(event: MouseEvent) {
	itsMe = true;
	const { clientX, clientY } = event;

	trigger.value = {
		getBoundingClientRect() {
			return {
				width: 0,
				height: 0,
				x: clientX,
				y: clientY,
				top: clientY,
				left: clientX,
				right: clientX,
				bottom: clientY,
			};
		},
		contextElement: contextElement.value,
	};

	show();
}

function show() {
	menuOpen.value = true;
	display.value = "flex";
}

function hide() {
	menuOpen.value = false;
	display.value = "none";
}

onClickOutside(menu, () => {
	hide();
});

window.addEventListener("contextmenu", () => {
	if (!itsMe) {
		hide();
	}

	itsMe = false;
});
</script>
